import { render, staticRenderFns } from "./Covid19.vue?vue&type=template&id=54893e0e"
import script from "./Covid19.vue?vue&type=script&lang=js"
export * from "./Covid19.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports